<template>
  <div class="about">
    <!-- nav -->
    <Navbar style="height: 7.3rem" id="top" />
    <!-- banner -->
    <section class="banner">
      <img src="@/assets/images/aboutbanner.png" alt="" />
    </section>
    <!-- tabInfo -->
    <div class="tabInfo" id="position">
      <div class="tab_L">
        <ul>
          <li
            :class="tabAct === item.id ? 'act' : ''"
            v-for="(item, index) in tabNav"
            :key="index"
            @click="tabFunc(item.id)"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>
      <div class="tab_R">
        <section v-if="tabAct === 1">
          <h1>ABOUT MOMODA</h1>
          <span class="line"></span>
          <h2>关于摩摩哒</h2>
          <p>{{ Background }}</p>
          <div>
            <img
              src="@/assets/images/aboutlogo.png"
              alt=""
              style="width: 49%; margin-right: 1.5%"
            />
            <img
              src="@/assets/images/rotaiFactory.png"
              alt=""
              style="width: 49%"
            />
          </div>
        </section>
        <section v-if="tabAct === 2">
          <h1>MOMODA BRAND</h1>
          <span class="line"></span>
          <h2>摩摩哒品牌</h2>
          <p
            v-for="(c, j) in ideaContant.slogan"
            :key="j"
            :class="j === 0 || j === 3 ? 'tit' : ''"
          >
            {{ c }}
          </p>
        </section>
        <section v-if="tabAct === 3">
          <h1>MOMODA DEVELOPMENT</h1>
          <span class="line"></span>
          <h2>发展历程</h2>
          <Steps />
        </section>
        <section v-if="tabAct === 4">
          <h1>MOMODA HONOR</h1>
          <span class="line"></span>
          <h2>资质荣誉</h2>
          <div class="honorImg">
            <div v-for="(a, e) in honor" :key="e">
              <img :src="a.imgurl" alt="" />
            </div>
          </div>
        </section>
      </div>
    </div>
    <!-- foot -->
    <Foot />
  </div>
</template>

<script>
import Navbar from "@/components/nav.vue";
import Foot from "@/components/foot.vue";
import Steps from "@/components/step.vue";
import { about } from "@/assets/js/data.js";
export default {
  name: "about",
  components: {
    Navbar,
    Foot,
    Steps,
  },
  data() {
    return {
      tabAct: 1,
      tabNav: about.tabNav,
      Background: about.Background,
      ideaContant: about.ideaContant,
      honor: about.honor,
    };
  },
  watch: {
    $route() {
      this.scroll();
    },
  },
  mounted() {
    this.scroll();
  },
  methods: {
    tabFunc(id) {
      this.tabAct = id;
    },
    scroll() {
      let id = Number(this.$route.query.id);
      if (id) {
        document
          .getElementById("position")
          .scrollIntoView({ behavior: "smooth" });
      }
      if (id === 1) {
        this.tabAct = id;
      } else if (id === 2) {
        this.tabAct = id;
      } else if (id === 3) {
        this.tabAct = id;
      } else if (id === 4) {
        this.tabAct = id;
      } else {
        document.getElementById("top").scrollIntoView({ behavior: "smooth" });
        this.tabAct = 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.about {
  .tabInfo {
    display: flex;
    align-items: flex-start;
    .tab_L {
      width: 30%;
      background: #e0e0e0;
      height: 65rem;
      ul {
        width: 50%;
        float: right;
        li {
          height: 3rem;
          line-height: 3rem;
          font-size: 1.3rem;
          text-align: center;
          margin-top: 1.2rem;
          cursor: pointer;
          color: #101010;
        }
        li.act {
          margin-left: 0.5rem;
          border-right: 0.5rem solid #f5bf4a;
          font-weight: bold;
        }
      }
    }
    .tab_R {
      width: 70%;
      background: #f1f1f1;
      height: 65rem;
      overflow-y: auto;
      section {
        margin: 2rem auto;
        width: 80%;
        h1 {
          color: #777778;
          font-size: 2.3rem;
          font-weight: bold;
        }
        h2 {
          margin: 1rem 0 3rem;
        }
        .line {
          display: block;
          width: 5rem;
          background: #bfbfbf;
          height: 0.2rem;
          margin-top: 1rem;
        }
        p {
          line-height: 3rem;
          font-size: 1.2rem;
          letter-spacing: 0.1rem;
        }
        p.tit {
          font-weight: bold;
          font-size: 1.3rem;
          margin-top: 1rem;
        }
        .honorImg {
          width: 90%;
          div {
            background: #fff;
            padding: 1rem;
            width: 15rem;
            vertical-align: top;
            margin-right: 2rem;
            margin-bottom: 2rem;
            display: inline-block;
            img {
              width: 15rem;
              height: 20rem;
            }
          }
        }
      }
    }
  }
}
</style>
